import Emissions from '@/services/emissions'
import Profile from '@/services/profile'
import Invite from '@/services/invite'

const fetchEmissions = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .fetch(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}
const getEmission = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .get(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const paymentHistory = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .paymentHistory(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const pusGraph = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .pusGraph(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const pus = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .pus(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const downloadPusHistory = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .downloadPusHistory(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const calcDesagio = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .calcDesagio(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const calcDesagioCetip = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .calcDesagioCetip(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const getDocs = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .getDocs(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const updateInvestorProfile = ({}, payload) => {
  return new Promise((resolve, reject) => {
    Profile.updateInvestorProfile(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const favorite = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .favorite(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const unfavorite = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const emissions = new Emissions('investidor')
    emissions
      .unfavorite(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const validateInvite = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const invite = new Invite('investidor')
    invite
      .validate(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

const acceptInvite = ({}, payload) => {
  return new Promise((resolve, reject) => {
    const invite = new Invite('investidor')
    invite
      .accept(payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

export default {
  pus,
  getDocs,
  pusGraph,
  favorite,
  unfavorite,
  getEmission,
  calcDesagio,
  acceptInvite,
  fetchEmissions,
  paymentHistory,
  validateInvite,
  calcDesagioCetip,
  downloadPusHistory,
  updateInvestorProfile,
}
